import { useProperties } from "@/composables/Property/useProperties";
import useAlert from "@/composables/useAlert";
import { useMetaData } from "@/composables/useMetaData";
import { useStore } from "@/composables/useTypedStore";
import useUser from "@/composables/useUser";
import BestandsaufnahmeModel from "@/models/ba/models/bestandsaufnahme.model";
import Immobilie from "@/models/immobilie.model";
import { setLocalMetaData } from "@/models/local-meta-data";
import { setCache } from "@/store/storage/ionicStorage";
import { useCreateSurvey } from "./useCreateSurvey";
import { useFaqs } from "./useFaqs";
import { Monitoring } from "@/utilities/monitoring";

export default function useFetchData() {

    const { fetchMetaData } = useMetaData();
    const { loadImmobilienPreviews } = useProperties();
    const { loadFaqs } = useFaqs();

    const store = useStore();
    const alert = useAlert();


    async function fetch(alertWhenOffline = false) {

        const uUser = useUser();

        if (!await uUser.isLoggedIn() || !uUser.isApproved.value) {
            return;
        }

        if(alertWhenOffline && store.getters['app/isOffline']){
            alert.show("Sie sind offline.", "Um aktuelle Daten zu erhalten, stellen Sie bitte eine Internetverbindung her.")
        }

        if (!store.getters['app/isOffline']){
            await setLocalMetaData('lastBackendFetch', (new Date()).toISOString())
        }

        if (uUser.user.value?.organisation?.featureFlags?.hideAppLinkBanner) {
            store.commit('app/setShowAppLinkBanner', false);
        }

        try {
            const templates = await useCreateSurvey().fetchTemplates()
            await setCache('cachedSurveyTemplates', JSON.stringify(templates))
        } catch(err) {
            Monitoring.consoleOnly(err)
        }
        await Promise.all([
            loadImmobilienPreviews(),
            BestandsaufnahmeModel.dispatch("loadBestandsaufnahmens")
        ]);
        uUser.fetchOrganisationUsers().then(( organizationUsers ) => {
            store.commit("user/setOrganizationUsers", organizationUsers);
        });
        fetchMetaData();
        loadFaqs();
    }

    /**
     * Discard current loaded data and load new
     */
    const doRefresh = async (clickEvent?: any) => {
        Monitoring.consoleOnly('doRefresh ...');
        
        BestandsaufnahmeModel.commit(state => state.page = 0);
        BestandsaufnahmeModel.deleteAll();
        Immobilie.dispatch("setPage", 0);
        Immobilie.deleteAll();

        await fetch(clickEvent ? true : false);
        clickEvent?.target?.complete();
    };

    return {
        fetch,
        doRefresh,
    }
}